<template>
  <div class="fullscreen bg-blue text-white text-center q-pa-md flex flex-center">
    <div>
      <div style="font-size: 20vh">{{ error?.statusCode }}</div>

      <div class="text-h3" style="opacity: 0.4">
        {{ error?.statusMessage || 'An error occurred.' }}
      </div>

      <q-btn
        v-if="canGoBack"
        class="q-mt-xl q-mx-md"
        color="white"
        icon="arrow_back"
        size="xl"
        text-color="blue"
        label="Go Back"
        no-caps
        @click="handleBack"
      />
      <q-btn
        class="q-mt-xl q-mx-md"
        color="white"
        icon="home"
        size="xl"
        text-color="blue"
        label="Go Home"
        no-caps
        @click="handleError"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object as () => NuxtError,
});

const router = useRouter();
const canGoBack = computed(() => import.meta.client && window.history.length > 1);

const handleError = () => clearError({ redirect: '/' })
const handleBack = () => router.back()
</script>
